module.exports = __webpack_public_path__ + "static/media/circle-low.7a2bc1a5.svg";